
import React from 'react';

const SolutionHeader = () => {
  return (
    <div className="max-w-3xl mx-auto text-center mb-16">
      <h2 className="heading-lg mb-6 reveal opacity-0 transition-all duration-700 translate-y-8">
        Meet Portco AI – The Future of Alternative Investment Analytics
      </h2>
      <p className="text-gray-600 text-lg reveal opacity-0 transition-all duration-700 translate-y-8" style={{ transitionDelay: '100ms' }}>
        Our AI-powered platform transforms how private equity firms analyze portfolio data, making insights more accessible, accurate, and actionable.
      </p>
    </div>
  );
};

export default SolutionHeader;
